module.exports = __webpack_public_path__ + "img/keys.ba608c1c.svg";